import { UrlPatternType, } from "./types.js";
const ExactUrlMatcher = {
    create(urlPattern) {
        const urlStr = urlPattern.url.toString();
        return {
            type: UrlPatternType.EXACT,
            match(url) {
                return urlStr === url.toString();
            },
        };
    },
};
const DomainUrlMatcher = {
    extractRootDomain(url) {
        try {
            let domain = new URL(url).hostname;
            const splitArr = domain.split(".");
            const arrLen = splitArr.length;
            //extracting the root domain here
            //if there is a subdomain
            if (arrLen > 2) {
                domain = splitArr[arrLen - 2] + "." + splitArr[arrLen - 1];
                //check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
                if (splitArr[arrLen - 2].length == 2 && splitArr[arrLen - 1].length == 2) {
                    //this is using a ccTLD
                    domain = splitArr[arrLen - 3] + "." + domain;
                }
            }
            return domain;
        }
        catch (err) {
            console.error(err);
        }
    },
    create(urlPattern) {
        const domain = urlPattern.domain ?? DomainUrlMatcher.extractRootDomain(urlPattern.url.toString());
        if (!domain)
            throw new Error("could not get domain");
        return {
            type: UrlPatternType.DOMAIN,
            match(url) {
                const urlDomain = DomainUrlMatcher.extractRootDomain(url);
                return urlDomain !== undefined && urlDomain === domain;
            },
        };
    },
};
const HostnameUrlMatcher = {
    create(urlPattern) {
        try {
            const hostname = urlPattern.hostname ?? new URL(urlPattern.url).hostname;
            return {
                type: UrlPatternType.HOSTNAME,
                match(url) {
                    try {
                        return hostname === new URL(url).hostname;
                    }
                    catch (err) {
                        return false;
                    }
                },
            };
        }
        catch (err) {
            throw new Error(`could not get hostname`);
        }
    },
};
const HostnameSuffixUrlMatcher = {
    create(urlPattern) {
        const suffix = urlPattern.hostnameSuffix.toLowerCase();
        return {
            type: UrlPatternType.HOSTNAME_SUFFIX,
            match(url) {
                try {
                    const { hostname } = new URL(url);
                    // The leading dot is what stops "notvideo.yuja.com" matching "video.yuja.com".
                    return hostname === suffix || hostname.endsWith(`.${suffix}`);
                }
                catch (err) {
                    return false;
                }
            },
        };
    },
};
const OriginUrlMatcher = {
    create(urlPattern) {
        try {
            const origin = urlPattern.origin ?? new URL(urlPattern.url).origin;
            return {
                type: UrlPatternType.ORIGIN,
                match(url) {
                    try {
                        return origin === new URL(url).origin;
                    }
                    catch (err) {
                        return false;
                    }
                },
            };
        }
        catch (err) {
            throw new Error(`could not get origin`);
        }
    },
};
const WildcardUrlMatcher = {
    create(urlPattern) {
        const wildcardPattern = urlPattern.pattern;
        return {
            type: UrlPatternType.WILDCARD,
            match(url) {
                const urlStr = url.toString();
                const matchLookup = Array.from(new Array(wildcardPattern.length + 1), (_) => new Array(urlStr.length + 1).fill(false));
                matchLookup[0][0] = true;
                for (let w = 0; w < wildcardPattern.length; w++) {
                    if (wildcardPattern[w] !== "*") {
                        break;
                    }
                    matchLookup[w + 1][0] = true;
                }
                for (let w = 0; w < wildcardPattern.length; w++) {
                    for (let u = 0; u < urlStr.length; u++) {
                        if (wildcardPattern[w] === "*") {
                            matchLookup[w + 1][u + 1] = matchLookup[w + 1][u] || matchLookup[w][u + 1];
                        }
                        else if (wildcardPattern[w] === "?" || wildcardPattern[w] === urlStr[u]) {
                            matchLookup[w + 1][u + 1] = matchLookup[w][u];
                        }
                        else if (wildcardPattern[w] !== urlStr[u]) {
                            matchLookup[w + 1][u + 1] = false;
                        }
                    }
                }
                return matchLookup[wildcardPattern.length][urlStr.length];
            },
        };
    },
};
const RegexUrlMatcher = {
    create(urlPattern) {
        let regexStr = urlPattern.regex.toString();
        if (!regexStr.startsWith("^")) {
            regexStr = `^${regexStr}`;
        }
        if (!regexStr.endsWith("$")) {
            regexStr = `${regexStr}$`;
        }
        const regex = new RegExp(regexStr);
        return {
            type: UrlPatternType.REGEX,
            match(url) {
                try {
                    return regex.test(url.toString());
                }
                catch (err) {
                    return false;
                }
            },
        };
    },
};
const CompositeUrlMatcher = {
    create(urlPattern) {
        const urlMatchers = urlPattern.urlPatterns.map((u) => createUrlMatcher(u));
        return {
            type: UrlPatternType.COMPOSITE,
            match(url) {
                return urlMatchers.some((m) => m.match(url));
            },
        };
    },
};
// TO DO USE LOCKDOWN's url matching?
export function createUrlMatcher(urlPattern) {
    switch (urlPattern.type) {
        case UrlPatternType.EXACT: {
            return ExactUrlMatcher.create(urlPattern);
        }
        case UrlPatternType.DOMAIN: {
            return DomainUrlMatcher.create(urlPattern);
        }
        case UrlPatternType.HOSTNAME: {
            return HostnameUrlMatcher.create(urlPattern);
        }
        case UrlPatternType.HOSTNAME_SUFFIX: {
            return HostnameSuffixUrlMatcher.create(urlPattern);
        }
        case UrlPatternType.ORIGIN: {
            return OriginUrlMatcher.create(urlPattern);
        }
        case UrlPatternType.WILDCARD: {
            return WildcardUrlMatcher.create(urlPattern);
        }
        case UrlPatternType.REGEX: {
            return RegexUrlMatcher.create(urlPattern);
        }
        case UrlPatternType.COMPOSITE: {
            return CompositeUrlMatcher.create(urlPattern);
        }
    }
}
//# sourceMappingURL=factory.js.map